import * as Types from '../action/types';

const initialState = {
  shouldRefresh: false
};

export default function brokerManagementReducer(state = initialState, action) {
  switch (action.type) {
    case Types.SEARCH_REFRESH:
      return {
        ...state,
        shouldRefresh: !state.shouldRefresh
      };
    default:
      return state;
  }
}
